import { useCallback, useEffect, useState } from 'react';

import Button from '../widgets/button';
import Card from '../widgets/card';
import List from '../widgets/list';

import { ReactComponent as SizeIcon } from '../../assets/icons/size.svg';
import { ReactComponent as CompactIcon } from '../../assets/icons/compact.svg';
import { ReactComponent as FilterIcon } from '../../assets/icons/filter.svg';

import sortDescendingIcon from '../../assets/icons/sort-za.svg';
import sortAscendingIcon from '../../assets/icons/sort-az.svg';

import { MdSearch } from 'react-icons/md';
import { IoIosArrowForward, IoIosArrowBack, IoIosArrowUp, IoIosArrowDown } from 'react-icons/io';

import CardLoader from '../loaders/card';
import store from '../../states';
import Dropdown from 'react-bootstrap/Dropdown';
import Sorting from '../widgets/sorting';
import { FixedSizeList } from 'react-window';

interface Props {
  title: string;
  kind: 'requestDeal';
  size: 'collapsed' | 'expanded';
  card: 'collapsed' | 'expanded';
  action?: {
    icon: string;
    text: string;
    click(): void;
    className?: string;
  };
  items: any[];
  empty?: boolean;
  selected?: string;
  sidebar?(size: string): void;
  info?(card: string): void;
  handleQueries?(query: any): void;
  setSelected?(): void;
  customerType?: string;
  icons?: boolean;
  getMoreData?(page: any): void;
  currentPage?: any;
  loading?: boolean;
  hasMore?: boolean;
  sortingBy?(sort: any): void;
  params?: any;
  handleParams?: any;
  searchToggle?: any;
  allData?: any;
}

const RequestDealSidebar = (props: Props) => {
  const {
    title,
    kind,
    size,
    card,
    action,
    items,
    sidebar,
    info,
    handleQueries,
    setSelected,
    icons,
    empty,
    getMoreData,
    currentPage,
    loading,
    hasMore,
    sortingBy,
    params,
    handleParams,
    allData,
  } = props;

  const [displayItems, sDisplayItems] = useState(items);
  const [selected, sSelected] = useState(props.selected);
  const [sideSize, sSideSize] = useState(size);
  const [cardSize, sCardSize] = useState(card);
  const [searchContent, sSearchContent] = useState('');
  const [searchBar, sSearchBar] = useState(false);
  const [contextMenu, sContextMenu] = useState(false);
  const [expandSearchBar, sExpandSearchBar] = useState(false);
  const [sortIcon, sSortIcon] = useState(sortDescendingIcon);
  const [expand, setExpand] = useState(false);

  const [glossary, sGlossary] = useState<any>({});
  useEffect(() => {
    sGlossary(store.getState());
    const unsubscribe = store.subscribe(() => {
      sGlossary(store.getState());
    });
    return () => unsubscribe();
  }, []);

  useEffect(() => {
    sSelected(props.selected);
  }, [props.selected]);

  useEffect(() => {
    sDisplayItems(items);
  }, [items, searchContent]);

  const [crSrt, sCrSrt] = useState(params.sortBy);

  const select = (id: any, item?: any) => {
    sSelected(id);
    if (info) info(id);
  };

  const toggleSearchBar = (e: Event) => {
    const allow1 = document.getElementById(`search-bar`);
    const allow3 = document.getElementById(`search-bar-expand`);
    const allow2 = document.getElementById(`search-btn`);
    const allow4 = document.getElementById(`search-btn-expand`);
    const target = e.target;
    if (target === allow1 || target === allow2 || target === allow3 || target === allow4) {
      //
    } else {
      sExpandSearchBar(false);
    }
  };

  const handleSidebar = () => {
    if (expand) {
      setExpand(false);
    } else {
      setExpand(true);
    }
  };

  const sorter = (key: string, desc: boolean) => {
    if (key === crSrt.id && (desc || !desc)) {
      sCrSrt({
        id: key,
        desc: desc,
      });
    } else {
      sCrSrt({
        id: key,
        desc: desc,
      });
    }
  };

  useEffect(() => {
    document.addEventListener('click', toggleSearchBar, false);
    //document.addEventListener('click', toggleFilterMenu, false);
    return () => {
      document.removeEventListener('click', toggleSearchBar, false);
      //document.removeEventListener('click', toggleFilterMenu, false);
    };
  }, []);

  const [pageIndex, setPageIndex] = useState(0);

  /* For Search */
  useEffect(() => {
    if (searchContent !== params.query) {
      const getData: any = setTimeout(() => {
        handleParams(0, searchContent, params.sortBy, true);
        sDisplayItems([]);
      }, 300);
      return () => clearTimeout(getData);
    }
  }, [searchContent, params.sortBy]);

  /***** Onscroll Fetch Data Start *****/
  const renderCard = ({ index, style }: any) => {
    const item = displayItems && displayItems[index];
    return (
      <div style={style}>
        <Card
          id={item.id}
          key={index}
          text={item.name}
          kind={'req-deal'} //change this
          size={cardSize}
          info={{
            items: item.config,
            created: item.created_on_formatted,
            minCpm: item.min_cpm_formatted,
            maxCpm: item.max_cpm_formatted,
            status: item.status,
            statusFormatted: item.status_formatted,
            userType: props.customerType,
          }}
          selected={selected}
          click={() => select(item.id, item)}
          setSelected={setSelected}
          allData={allData}
        />
      </div>
    );
  };

  const lastItem = displayItems[displayItems.length - 1];
  const handleItemsRendered = useCallback(
    ({ visibleStartIndex, visibleStopIndex }) => {
      if (
        //params.page === currentPage &&
        displayItems?.length >= 500 &&
        hasMore &&
        visibleStopIndex === displayItems.length - 1 &&
        lastItem
      ) {
        handleParams(params.page, params.query, params.sortBy, true);
      }
    },
    [params.page, params.query, params.sortBy, displayItems.length, lastItem]
  );

  useEffect(() => {
    if (currentPage === 0) setPageIndex(0);
  }, [currentPage]);

  /***** Onscroll Fetch Data End *****/

  /***** Handle Sorting Start *****/
  const handleSort = (sort: any) => {
    if (sort) {
      sCrSrt(sort);
      handleParams(0, params.query, sort, true);
      setPageIndex(0);
      sDisplayItems([]);
    }
  };
  /***** Handle Sorting End *****/

  const handleSearch = () => {
    if (searchBar) {
      sSearchBar(false);
      props?.searchToggle && props?.searchToggle(searchBar);
    } else {
      sSearchBar(true);
      props?.searchToggle && props?.searchToggle(searchBar);
    }
  };

  return (
    <>
      <div className={expand ? 'newsidebar open' : 'newsidebar'}>
        <div className={'sidebar-row sidebar-row-first'}>
          <div className={'sidebar-col'}>
            <h3>{title}</h3>
          </div>
          <div className={'sidebar-col'}>
            <div className={'sidebar-row'}>
              {searchBar && (
                <div className={'sidebar-col'}>
                  <input
                    autoFocus
                    onChange={(e) => {
                      if (e.target.value === '') {
                        sSearchContent('');
                      } else {
                        sSearchContent(e.target.value);
                      }
                    }}
                    id={'search-bar'}
                    value={searchContent}
                    type={'search'}
                    placeholder={'Search Keywords..'}
                    maxLength={32}
                    className='search-input ps-0'
                    style={{
                      width: '245px',
                      maxWidth: '245px',
                      position: 'absolute',
                      // position: expand ? 'inherit' : 'absolute',
                      left: '25px',
                      height: '35px',
                    }}
                  />
                </div>
              )}
              <div className={'sidebar-col'}>
                <MdSearch
                  className='svg-icon'
                  id={'search-btn'}
                  onClick={() => {
                    handleSearch();
                  }}
                  title={'Search'}
                  fontSize={20}
                  style={{ marginLeft: 8, marginRight: 5 }}
                />
              </div>

              <div className={!searchBar ? 'sidebar-col' : 'd-none'}>
                <Sorting kind={'requestDeal'} sortBy={handleSort} sortedBy={crSrt} />
              </div>

              {!searchBar && (
                <>
                  <div
                    className={'sidebar-col compact-card'}
                    onClick={() => sCardSize(cardSize === 'collapsed' ? 'expanded' : 'collapsed')}
                  >
                    {cardSize === 'expanded' ? (
                      <SizeIcon
                        className='svg-icon'
                        width={20}
                        height={20}
                        title='Collapse'
                        style={{ marginLeft: 8, cursor: 'pointer' }}
                      />
                    ) : (
                      <CompactIcon
                        className='svg-icon'
                        width={20}
                        height={20}
                        title='Expand'
                        style={{ marginLeft: 8, cursor: 'pointer' }}
                      />
                    )}
                  </div>
                </>
              )}

              {/* {displayItems?.length > 0 && (
                <div className='sidebar-col toggle ms-1' onClick={handleSidebar}>
                  <IoIosArrowForward fontSize={18} className='svg-icon' />
                </div>
              )} */}
            </div>
          </div>
        </div>

        <div className={'sidebar-row sidebar-row-secound'}>
          <div className={'sidebar-col'} id='first-btn'>
            {action && (
              <div style={{ marginTop: 16, marginBottom: 16 }}>
                <Button
                  kind={'primary'}
                  icon={action.icon}
                  text={action.text}
                  click={action.click}
                  customClass={action.className}
                />
              </div>
            )}
          </div>
        </div>

        <div
          className={'sidebar-list'}
          style={{ minWidth: 300, marginTop: props.customerType !== 'demand' ? '40px' : '0px' }}
        >
          {/***** List of Sidebar Card *****/}
          <FixedSizeList
            height={1000}
            width={300}
            itemCount={displayItems.length}
            itemSize={cardSize === 'collapsed' ? 75 : 130}
            onItemsRendered={handleItemsRendered}
            style={{
              width: '100%',
              height: displayItems.length > 0 ? `calc(100vh - 140px)` : `0px`,
              overflowY: 'auto',
            }}
          >
            {renderCard}
          </FixedSizeList>

          {/***** Skeleton View *****/}
          {loading && (
            <>
              <div className='mb-3'>
                <CardLoader />
                <CardLoader />
                <CardLoader />
              </div>
            </>
          )}

          {/***** When data not found on search *****/}
          {(!displayItems || displayItems.length < 1 || searchContent.length > 0) && !loading && (
            <>{props.empty && <p style={{ textAlign: 'center', padding: 24 }}>No Results</p>}</>
          )}
        </div>
      </div>
    </>
  );
};

export default RequestDealSidebar;
